import { API_CONSTANTS } from "../../constants/apiConstants";
import baseApi from "./baseApiService";

export const ReportingLogsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPatientBillingReportInfo: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.PATIENT_BILLING_REPORTS_INFO}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
    getDraftCareServiceInfo: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_DRAFT_CARE_SERVICE_INFO}`,
        method: "POST",
        body: JSON.stringify(request),
        headers:{
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
    generateReport: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GENERATE_REPORT}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
    generateDraftCareServiceReport: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GENERATE_DRAFT_CARE_SERVICE_REPORT}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
    downloadReport: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.DOWNLOAD_REPORT}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
        responseHandler: async (response) => {
          const blobData = await response.blob();
          return blobData;
        },
        cache: "no-cache",
      }),
      transformResponse: (data, meta: any, args) => {
        return { data, headers: meta?.response?.headers };
      },
    }),
    downloadDraftCareServiceReport: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.DOWNLOAD_DRAFT_CARE_SERVICE_REPORT}`,
        method: "POST",
        body:JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
        responseHandler: async (response) => {
          const blobData = await response.blob();
          return blobData;
        },
        cache: "no-cache",
      }),
      transformResponse: (data, meta: any, args) => {
        return { data, headers: meta?.response?.headers };
      },
    }),
  }),
});
export const {
  useLazyGetPatientBillingReportInfoQuery,
  useLazyGetDraftCareServiceInfoQuery,
  useLazyGenerateReportQuery,
  useLazyGenerateDraftCareServiceReportQuery,
  useLazyDownloadReportQuery,
  useLazyDownloadDraftCareServiceReportQuery,
} = ReportingLogsApi;
